import { render, staticRenderFns } from "./OutBidNotificationSettings.vue?vue&type=template&id=44b5516e&"
import script from "./OutBidNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./OutBidNotificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b5516e')) {
      api.createRecord('44b5516e', component.options)
    } else {
      api.reload('44b5516e', component.options)
    }
    module.hot.accept("./OutBidNotificationSettings.vue?vue&type=template&id=44b5516e&", function () {
      api.rerender('44b5516e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lot/components/OutBidNotificationSettings.vue"
export default component.exports